module.exports = __webpack_public_path__ + "img/Erythranthe_guttata.0dca8800.jpg";